import { colors } from '@ardoq/design-tokens';
import { range } from 'lodash';
import { tint } from 'polished';

const chartPalette = [
  colors.blue600,
  colors.yellow600,
  colors.purple25,
  colors.green600,
];

/**
 * @param value a number greater than or equal to 1.
 * @returns a number between 0.25 and 0.75. the difference between consecutive numbers will grow increasingly smaller as the value parameter increases.
 * @example
 * tintValue(1) // returns 0.25
 * tintValue(2) // returns 0.4166666666666667
 * tintValue(3) // returns 0.5
 * tintValue(1000000000) // returns 0.749999999
 */
const tintValue = (value: number) => 0.75 - 1 / (value + 1);

/** @returns a color from {@link chartPalette}, or, if index exceeds the {@link chartPalette}, a tinted variation of the {@link chartPalette} color. */
export const getRangeColor = (index: number) =>
  index < chartPalette.length
    ? chartPalette[index]
    : tint(
        tintValue(Math.floor(index / chartPalette.length)),
        chartPalette[index % chartPalette.length]
      );

export const getColorRange = (howMany = 1) =>
  range(0, howMany).map(getRangeColor);

const colorRange = getColorRange(5);

/** @returns {Record<string, string>} */
const getDefaultLevelColors = () => ({
  level1: colorRange[0],
  level2: colorRange[1],
  level3: colorRange[2],
  level4: colorRange[3],
  level5: colorRange[4],
});

export const isValidColorHex = (hex = '') => {
  return /^#?([a-fA-F]|\d){3,8}$/.test(hex);
};

const STRICT_COLOR_HEX =
  /^#(?:[0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;

/**
 * Unlike {@link isValidColorHex}, requires the `#` and a digit count CSS allows.
 */
export const isStrictColorHex = (hex: string | undefined): boolean =>
  hex !== undefined && STRICT_COLOR_HEX.test(hex);

export const DEFAULT_COLORS = getDefaultLevelColors();
